import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideCard,
  GuideCardGrid,
  GuidePillar,
  GuidePillarGrid,
} from "../GuideBlocks.js";

const MentalClarityForLeadersSection = ({ heading, accentIndex = 1 }) => (
  <GuidePanel sectionId="mental-clarity-for-leaders" heading={heading} accentIndex={accentIndex}>
    <GuidePillarGrid columns={3}>
      <GuidePillar title="Self-leadership first">
        Before leading others, leaders must learn to lead their own thoughts, emotions, and decisions.
      </GuidePillar>
      <GuidePillar title="Thinking shapes outcomes">
        The quality of a leader&apos;s thinking shapes every decision, conversation, and outcome that follows.
      </GuidePillar>
      <GuidePillar title="Clarity under uncertainty">
        Leadership is less about having all the answers and more about deciding well without them.
      </GuidePillar>
    </GuidePillarGrid>
    <GuideSectionLabel>Leaders with strong mental clarity demonstrate</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="growth" title="Better strategic decisions" />
      <GuideCard iconKey="stress" title="Greater emotional resilience" />
      <GuideCard iconKey="energy" title="Lower decision fatigue" />
      <GuideCard iconKey="communication" title="More productive conversations" />
      <GuideCard iconKey="growth" title="Increased team trust" />
      <GuideCard iconKey="awareness" title="Realistic outlook in uncertainty" />
    </GuideCardGrid>
  </GuidePanel>
);

export default MentalClarityForLeadersSection;
